/* unplugin-vue-components disabled */import script from "./gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./gallery.vue?vue&type=script&setup=true&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=1b617ddb&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b617ddb"]])

export default __exports__